var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyEyeSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97813 10.5C10.1281 10.5 12.5781 7.7875 13.6281 6.2125C14.0656 5.6 14.0656 4.8125 13.6281 4.2C12.5781 2.7125 10.1281 0 6.97813 0C3.82813 0 1.37813 2.7125 0.328125 4.2875C-0.109375 4.9 -0.109375 5.6875 0.328125 6.2125C1.37813 7.7875 3.82813 10.5 6.97813 10.5ZM6.97813 2.625C8.46563 2.625 9.60313 3.7625 9.60313 5.25C9.60313 6.7375 8.46563 7.875 6.97813 7.875C5.49063 7.875 4.35313 6.7375 4.35313 5.25C4.35313 3.7625 5.49063 2.625 6.97813 2.625Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyEyeSymbol);
export default __webpack_public_path__ + "static/media/policyEyeSymbol.b8dd76263e02be9b1a798d68b3c72014.svg";
export { ForwardRef as ReactComponent };